export default function isMobileApp() {
    return window.navigator.userAgent.includes('type:coflyt-native');
}